import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["activeStep", "steps", "className"];
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { visuallyHidden } from '@mui/utils';
import { ThemeProvider } from '@mui/material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import classname from 'classnames';
import { stepperTheme } from './stepperStyles';
export var EmbersStepper = function EmbersStepper(_ref) {
  var activeStep = _ref.activeStep,
    steps = _ref.steps,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visiableToSR = _useState2[0],
    setVisiableToSR = _useState2[1];
  var _steps;
  if (typeof steps === 'number') {
    _steps = new Array(steps).fill('');
  } else {
    _steps = steps;
  }
  var stepIcon = function stepIcon(stepIconProps) {
    var active = stepIconProps.active,
      completed = stepIconProps.completed,
      icon = stepIconProps.icon;
    var index = icon;
    var className = completed ? 'icon-completed' : "icon-number-".concat(index).concat(active ? '-fill' : '');
    return /*#__PURE__*/React.createElement("i", {
      className: classname(className, {
        active: active,
        completed: completed
      }),
      role: "img",
      "aria-label": intl.formatMessage({
        id: 'embers.stepper.eA.stepActive',
        defaultMessage: 'Step {number} of {total}'
      }, {
        number: index,
        total: Array.isArray(steps) ? steps.length : steps
      })
    });
  };
  var speechAloud = function speechAloud(index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "Embers-sr-only",
      style: visuallyHidden,
      "aria-live": "polite"
    }, intl.formatMessage({
      id: 'embers.stepper.eA.stepActive',
      defaultMessage: 'Step {number} of {total}'
    }, {
      number: index + 1,
      total: Array.isArray(steps) ? steps.length : steps
    }) + ' ' + _steps[index]);
  };
  var renderSteps = function renderSteps() {
    return _steps.map(function (label, index) {
      return /*#__PURE__*/React.createElement(Step, {
        key: label || index,
        className: classname({
          'active-step': activeStep === index
        }),
        "aria-current": activeStep === index ? 'step' : 'false',
        "aria-hidden": visiableToSR ? undefined : 'true'
      }, /*#__PURE__*/React.createElement(StepLabel, {
        StepIconComponent: stepIcon
      }, label));
    });
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: stepperTheme
  }, /*#__PURE__*/React.createElement(Stepper, _extends({
    activeStep: activeStep,
    alternativeLabel: true,
    className: classname('EmbersStepper-root', className),
    onMouseEnter: function onMouseEnter() {
      setVisiableToSR(true);
    },
    onMouseLeave: function onMouseLeave() {
      setVisiableToSR(false);
    }
  }, props), renderSteps()), speechAloud(activeStep));
};